{
    "LockedOut": "Usuário bloqueado:",
    "PromptTos": "Termos de serviço imediatos:",
    "NotifyPasswordChange": "Notificar alteração de senha:",
    "UpdateInterval": "Intervalo de atualização do relatório:",
    "UpdateIntervalCharacter": "s",
    "UpdateIntervalValidation": "O intervalo de atualização do relatório tem um máximo de 180 segundos",
    "MediaPlayer": "Desative os plug-ins do Media Player:",
    "DragAndDrop": "Recursos de arrastar e soltar desativados:",
    "JavascriptOutput": "Saída de auditoria JavaScript:",
    "AutoValue": "[Auto]",
    "SettingsLanguage_ServiceNotification": "Notificação de serviço:",
    "SettingsLanguage_ConcurrentSignins": "Logins simultâneos permitidos:",
    "SettingsLanguage_AdvancedTitle": "Diagnóstico avançado",
    "NAME": "SettingsLanguage",
    "SettingsLanguage_AuthNotifications": "Notificação de autorização:",
    "SettingsLanguage_NewDeviceNotifications": "Notificações de aprovisionamento:",
    "SettingsLanguage_AuthNotifications_Help": "Ativar as Notificações de Autenticação significa que o administrador receberá um e-mail sobre a autorização bem sucedida de um Servidor de Telefonia do MS Teams",
    "SettingsLanguage_NewDeviceNotifications_Help": "Ativar as Notificações de Provisionamento significa que o administrador receberá um e-mail quando um novo dispositivo for adicionado ou o modo de integração for alterado numa Instância do MS Teams"
}